<div class="indent-left-md">
    <div class="navbar-header">
        <p class="home-page-title">Synonym</p>
    </div>

    <div class="row">
        <i *ngIf="_pageState.isLoading" class="fa fa-circle-o-notch fa-spin" style="font-size:38px; color: #337ab7; margin-left: 24px;"></i>
    </div>

    <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
        <ul class="nav navbar-nav navbar-form">
            <li>
                <select class="btn btn-primary dropdown-toggle" [ngModel]="_pageState.operatorName" (change)="opChange($event)" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                    <option *ngFor="let op of _operators" class="dropdown" [value]="op.name"> {{op.title}}</option>
                </select>
            </li>
            <li>
                <input type="text" class="form-control" [(ngModel)]="_pageState.searchTerm" autocomplete="off" />
            </li>
            <li>
                <button type="button" class="btn btn-primary" (click)="newSearch()" [disabled]="!_pageState.searchTerm">Search</button>
            </li>
            <li>
                <button type="button" class="btn btn-primary" (click)="clear()" [disabled]="!_pageState.searchTerm">Clear</button>
            </li>
        </ul>
    </div>

    <div *ngIf="hasStatusMessage()" class="bold alert alert-warning">
        <span class="page-subtitle inline bold">{{_pageStatusMessage}}</span>
    </div>

    <div style="padding-right: 40px; width: 80%;">
        <p *ngIf="_totalItemCount > 0" class="page-subtitle bold">Click a row in the table to view the Material's information.</p>
        <dx-data-grid id="raDataGrid"
                      [dataSource]="dataSource"
                      [columnAutoWidth]="true"
                      [showRowLines]="true"
                      [rowAlternationEnabled]="true"
                      [showBorders]="true"
                      [hoverStateEnabled]="true"
                      [allowColumnReordering]="true"
                      [allowColumnResizing]="true"
                      (onSelectionChanged)="onSelectMaterial($event)">
            <dxo-paging [enabled]="true" [pageSize]="50"></dxo-paging>
            <dxo-remote-operations [sorting]="true" [paging]="true"></dxo-remote-operations>
            <dxo-pager [showNavigationButtons]="true" [visible]="true" infoText="Page #{0}. Total: {1} ({2} Synonyms)"></dxo-pager>
            <dxo-sorting mode="none"></dxo-sorting>
            <dxo-selection mode="single"></dxo-selection>

            <dxi-column caption="CAS No." dataField="materialCASNumber" alignment="left"></dxi-column>
            <dxi-column caption="RIFM ID" dataField="materialFormattedRIFMId"></dxi-column>
            <dxi-column caption="FEMA No." dataField="materialFEMANumber" alignment="center"></dxi-column>
            <dxi-column caption="Synonym" dataField="synonymWord"></dxi-column>
        </dx-data-grid>
    </div>

</div>
